import { ApolloCache } from 'apollo-cache'
import { NormalizedCacheObject } from 'apollo-cache-inmemory'

import {
  GetDocumentListSettingsDocument,
  GetDocumentListSettingsQuery,
} from 'gqlTypes'

export const initializeLocalApolloState = (
  cache: ApolloCache<NormalizedCacheObject>
) => {
  // Initialize the DocumentLayout grid setting on cache
  cache.writeQuery<GetDocumentListSettingsQuery>({
    query: GetDocumentListSettingsDocument,
    data: {
      __typename: 'RootQueryType',
      documentsLayout: 'GRID',
      showDocumentsInProjects: true,
    },
  })
}
